import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Gallery from "../Gallery";
import Hero from "../Hero";
import Intro from "./Intro";

export default function GenTemplate() {
  const { slug } = useParams();
  const [dynamicContent, setDynamicContent] = useState({});

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await fetch(
          `/assets/portfoliopages/generative/${slug}.json`
        );
        if (response.ok) {
          const text = await response.text();
          const parsedContent = JSON.parse(text);
          setDynamicContent(parsedContent);
        }
      } catch (error) {
        console.error(`An error occurred: ${error}`);
      }
    };
    fetchContent();
  }, [slug]);

  return (
    <div>
      <Hero />
      <Intro dynamicContent={dynamicContent} />
      <Gallery slug={slug} />
    </div>
  );
}
